import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  position: relative;
  top: 33px;
  transition: background 0.3s linear;

  .editor {
    flex: 1;
    width: 100%;
    position: relative;

    h1 {
      margin: 0;
      padding: 0;
    }
  }

  &.sw2 {
    top: 0;
    /* iOS pans the visual viewport (not the document) to reveal a focused input while the
       software keyboard is up. Shift the whole app by that pan so it stays aligned with the
       visible area instead of only the toolbar (SW-10329 / SW-10375). */
    html.ios-viewport & {
      top: var(--app-viewport-offset, 0px);
    }
  }

  /* &.story-bible-in-view {
    background: var(--primary-cta-transparent-15);
    transition: background 0.3s linear;
  } */

  .inner {
    /* width: 95%; */
    position: relative;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0;
    text-align: left;

    &.sw2 {
      max-width: none;
      display: flex;
      flex-direction: column;
    }
  }

  .project-menu {
    width: 100%;
    margin: 10px 0 0 0;
    padding: 0;
    min-height: 50px;
    &.sw2 {
      margin-top: 0;
      position: relative;
      z-index: 100000;
      top: var(--app-viewport-offset, 0px);
      html.ios-viewport & {
        top: 0;
      }
      transition:
        transform 980ms cubic-bezier(0.16, 0.9, 0.18, 1),
        filter 680ms ease,
        opacity 680ms ease;
    }
    &.collapsed {
      min-height: 10px;
    }

    .sw2-menu-loading-placeholder {
      display: flex;
      align-items: center;
      height: 50px;
      margin-left: 16px;
      margin-right: 16px;
      overflow: hidden;
      white-space: nowrap;
      box-sizing: border-box;
    }

    .sw2-menu-loading-tool {
      display: inline-flex;
      align-items: center;
      height: 40px;
      margin-right: 10px;
      padding: 0 15px;
      border-radius: 20px;
      background: var(--document-background);
      color: var(--grey-0);
      font-family: Inter;
      font-size: 16px;
      font-weight: 500;
      line-height: 27px;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
      box-sizing: border-box;
      flex: 0 0 auto;

      img,
      svg {
        width: 22px;
        height: 22px;
        margin-right: 9px;
        opacity: 1;
      }
    }
  }

  .project-main {
    display: flex;
    height: calc(var(--app-height) - 98px);
    position: relative;

    &.sw2 {
      height: calc(var(--app-height) - 98px - var(--banner-height, 0px));
      transition:
        height 0.3s,
        transform 980ms cubic-bezier(0.16, 0.9, 0.18, 1),
        filter 680ms ease,
        opacity 680ms ease;
      .collapsed-left-bar {
        left: 10px;
      }
      &.center-collapsed {
        height: calc(var(--app-height) - 10px - var(--banner-height, 0px));
      }
    }

    .collapsed-left-bar {
      position: absolute;
      /* background: none; */
      left: 14px;
      top: 14px;
      z-index: 1000;

      svg {
        width: 18px;
        path {
          fill: var(--grey-2);
        }
      }
    }

    .left-bar {
      position: relative;
      text-align: left;
      background: var(--document-background);
      border-right: 2px solid var(--divider);
      border-radius: 15px 0 0 0;
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);

      &.sw2 {
        max-width: none;
        border-radius: 0 28px 28px 0;
        margin-bottom: 10px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
        border-right: none;
        box-sizing: border-box;

        &.styled-scrollbars {
          &::-webkit-scrollbar {
            width: 8px;
          }
          &::-webkit-scrollbar-track {
            background: var(--scrollbar-track);
          }
          &::-webkit-scrollbar-thumb {
            background-color: var(--scrollbar-thumb);
            border-radius: 5px;
          }
          &::-webkit-scrollbar-thumb:hover {
            background-color: var(--scrollbar-thumb-hover);
          }
        }

        &.collapsed {
          background: transparent;
          box-shadow: none;
          border-right: 2px solid transparent;
          overflow: visible;
          *:not(.leftbar-component-container, .top-menu, .collapse, .collapse *) {
            display: none;
          }

          /* .top-menu creates the stacking context; lift it above the resize gutters (999) */
          .top-menu {
            z-index: 1000;
          }

          .collapse {
            left: 15px;
            right: unset;
            width: 48px;
            height: 48px;
            /* Above the column-resize gutters (z-index 999) so the re-open button stays clickable */
            z-index: 1000;

            svg {
              width: 24px;
              height: 24px;

              path {
                fill: var(--grey-0);
              }
            }
          }
        }
      }

      svg {
        &.folders {
          transform: translateY(1px);
          path {
            fill: var(--grey-0);
          }
        }
      }
    }
  }

  &.style-guide-menu-open {
    .project-menu.sw2 {
      transform: translateY(clamp(300px, 42vh, 430px));
      filter: blur(12px);
      opacity: 0;
      pointer-events: none;
    }

    .project-main.sw2 {
      transform: translateY(clamp(300px, 42vh, 430px));
      filter: blur(12px);
      opacity: 0.62;
      pointer-events: none;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .project-menu.sw2,
    .project-main.sw2 {
      transition-duration: 1ms;
      transition-delay: 0ms;
    }

    &.style-guide-menu-open {
      .project-menu.sw2,
      .project-main.sw2 {
        transform: none;
      }
    }
  }

  .empty-project {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 24px;
    background: var(--document-background);
    border-radius: 30px;
    max-height: calc(var(--app-height) - 118px);
    margin-left: 28px;
    margin-right: 28px;
  }

  .empty-project-content {
    max-width: 420px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    h2 {
      margin: 0;
      font-size: 22px;
      color: var(--grey-0);
    }

    p {
      margin: 0;
      color: var(--grey-2);
    }
  }
`;
